"use client";

import { useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { XRAY_URL } from "./config";
interface XrayResponse {
  use?: string;
}
export const XrayBeacon = () => {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) {
      return;
    }
    fired.current = true;
    if (Cookies.get("pie6")) {
      return;
    }
    const controller = new AbortController();
    const run = async () => {
      try {
        const res = await fetch(XRAY_URL, {
          credentials: "omit",
          cache: "no-store",
          signal: controller.signal
        });
        if (!res.ok) {
          throw new Error(`xray responded ${res.status}`);
        }
        const body = (await res.json()) as XrayResponse;
        const use = body?.use;
        if (typeof use === "string" && use.length > 0) {
          Cookies.set("pie6", use, {
            secure: process.env.NODE_ENV === "production",
            sameSite: "lax",
            expires: 1
          });
        }
      } catch (err) {
        if ((err as Error)?.name === "AbortError") {
          return;
        }
        console.error(err);
      }
    };
    void run();
    return () => controller.abort();
  }, []);
  return null;
};